import Styles from "../../pages/Styles/NomineeStyles.module.scss";
import {
  Stack,
  TextField,
  Typography,
  Checkbox,
  Grid,
  FormHelperText,
} from "@mui/material";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import calenderImage from "../../Components/assets/Images/calendar.svg";
import NomineeBar from "./NomineeBar";
import SelectProof from "./SelectProof";
import { ISelectProofProps, INomineeFormProps } from "../../shared/dtos";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import DropdownComp from "./DropDownComp";
import DatePickerComp from "./DatePickerComp";
import { nomineeID } from "../../shared/commonData";
import Checkboxempty from "../../Components/assets/Images/Checkboxempty.svg";
import Checkboxdone from "../../Components/assets/Images/Checkbox_blue.svg";
import { useState } from "react";

const maxDate = dayjs().subtract(99, "year");
const eighteenYearsAgo = dayjs().subtract(18, "year");
const todayDate = dayjs();

export default function NomineeForm({
  nominee,
  errorData,
  touchedData,
  index,
  currentIndex,
  handleChangeField,
  setFieldValue,
  values,
  handleBlur,
  relationError,
  ageError,
  relationShipData,
  handleNomineeDelete,
  handleNomineeEdit,
  setErrors,
  errors,
  address,
  gaurdianData,
  statesData,
  setTouched,
  touched,
  nominees,
  mode,
  showAdditionalDetails,
}: INomineeFormProps) {
  const [showGuardianAdditionalDetails, setShowGuardianAdditionalDetails] =
    useState(false);
  const handleSetAddress = (
    values: any,
    callBack: any,
    index: any,
    value: any,
  ) => {
    const addressState = (address.State || "").trim().toUpperCase();
    const selectedState = statesData.find(
      (data: any) => (data.value || "").trim().toUpperCase() === addressState,
    );
    const nomineeCopy: any = values.nominees.map(
      (nomineeData: any, nomineeIndex: number) =>
        nomineeIndex === index
          ? {
              ...nomineeData,
              nomineeAddress: value ? address.address : "",
              nomineeAddressCity: value ? address.city : "",
              nomineeAddressPinCode: value ? address.pincode : "",
              nomineeAddressState: value ? selectedState || "" : "",
            }
          : nomineeData,
    );
    callBack("nominees", nomineeCopy);
  };

  function DateIcon(props) {
    return (
      <img
        src={calenderImage}
        style={{
          width: "25px",
          paddingRight: "8px",
          // filter:
          //   mode === "dark" ? "grayscale(0.9) invert(0.9) brightness(1)" : "",
        }}
      />
    );
  }
  const handleSetGaurdianAddress = (
    values: any,
    callBack: any,
    index: any,
    value: any,
  ) => {
    //  console.log("values", values);
    const SelectedStateGaurdian = statesData.filter(
      (data: any) => data.value.toUpperCase() === address.State.toUpperCase(),
    )[0];
    // console.log("SelectedStateGaurdian",SelectedStateGaurdian)
    const nomineeCopyguardian: any = [...values.nominees];
    nomineeCopyguardian[index]["gaurdianAddress"] = value
      ? address.address
      : "";
    nomineeCopyguardian[index]["gaurdianAddressCity"] = value
      ? address.city
      : "";
    nomineeCopyguardian[index]["gaurdianAddressPinCode"] = value
      ? address.pincode
      : "";
    nomineeCopyguardian[index]["gaurdianAddressState"] = value
      ? SelectedStateGaurdian
      : "";
    callBack("nominees", nomineeCopyguardian);
  };

  const handleDelete = () => {
    handleNomineeDelete(values, setFieldValue, index);
  };
  const handleEdit = () => {
    handleNomineeEdit(index);
  };

  const percentageTotal = values.nominees
    .map((a: any) =>
      a.percentageofShare === "" ? 0 : parseFloat(a.percentageofShare),
    )
    .reduce((sum: any, current: any) => sum + current, 0);

  const check18YearOfAge = (dob: any): boolean => {
    if (!dob) return true;

    const birthDate = new Date(dob);
    const today = new Date();

    const ageInMs = today.getTime() - birthDate.getTime();
    const ageInYears = ageInMs / (1000 * 60 * 60 * 24 * 365.25);

    return ageInYears >= 18;
  };

  const dateCheck = nominee.relationShip
    ? nominee.relationShip?.guardian_req
      ? todayDate
      : eighteenYearsAgo
    : eighteenYearsAgo;

  const dateCheckError = nominee.relationShip
    ? !nominee.relationShip?.guardian_req
      ? check18YearOfAge(nominee.nomineeDateofBirth)
        ? ""
        : "Age should be above 18 years"
      : ""
    : "";
  const dateCheckErrorgaurdianDateofBirth = nominee.gaurdianDateofBirth
    ? check18YearOfAge(nominee.gaurdianDateofBirth)
      ? ""
      : "Guardian age should be above 18 years"
    : "";

  const filteredRelation = relationShipData?.filter(
    (a: any) =>
      a.value !== "Son" &&
      a.value !== "Spouse" &&
      a.value !== "Daughter" &&
      a.value !== "Grand son" &&
      a.value !== "Grand daughter",
  );

  return (
    <div style={{ width: "100%" }}>
      {/* <div style={{ width: "100%" }}>
        <NomineeBar
          index={index}
          onEditClick={handleEdit}
          onDeleteClick={handleDelete}
          percentageofShare={nominee.percentageofShare}
          currentIndex={currentIndex}
          nominees={nominees}
        />
      </div> */}
      <div className={Styles.tfmWrapper}>
        <div className={Styles.leftSubContainer}>
          <div>
            <div
              style={{
                display: currentIndex !== index ? "none" : "block",
              }}
              className={Styles.fieldsSection}
            >
              <div className={Styles.NewDesignWrapper}>
                <div className={Styles.newFeildWrapper}>
                  <div className={Styles.labeltext}>Nominee's Full Name </div>
                  <TextField
                    autoComplete="new-password"
                    className={Styles.textfields}
                    fullWidth
                    id="outlined-basic"
                    placeholder="Nominee's Full name"
                    variant="outlined"
                    name="nomineeFullName"
                    value={nominee.nomineeFullName}
                    error={
                      touchedData.nomineeFullName &&
                      !nominee.nomineeFullName &&
                      errorData &&
                      Boolean(errorData["nomineeFullName"])
                    }
                    onChange={(event) => {
                      handleChangeField(
                        "nomineeFullName",
                        event.target.value.toUpperCase(),
                        setFieldValue,
                        index,
                        values,
                        setErrors,
                        errors,
                        setTouched,
                        touched,
                      );
                    }}
                    onBlur={handleBlur}
                    inputProps={{
                      sx: {
                        "&::label": {
                          fill: "var(--ds-text-primary)",
                          fontWeight: 400,
                          fontSize: "14px",
                        },
                        color: "var(--ds-text-primary)",
                        fontSize: "14px",
                      },
                      maxLength: 50,
                      inputMode: "text",
                    }}
                    sx={{
                      fieldset: {
                        borderColor: "#E5E7EB",
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        color: "var(--ds-text-primary)",
                        fontWeight: 400,
                        fontSize: "14px",
                        "&.MuiFormLabel-filled": {
                          color: "var(--ds-text-primary)",
                          fontWeight: 400,
                          fontSize: "15px",
                          fontFamily: "inherit",
                        },
                      },
                    }}
                  />
                  <FormHelperText
                    style={{ color: "#d32f2f", textAlign: "center" }}
                  >
                    {touchedData.nomineeFullName &&
                    errorData &&
                    errorData["nomineeFullName"]
                      ? touchedData.nomineeFullName &&
                        errorData &&
                        errorData["nomineeFullName"]
                      : relationError
                        ? "Nominees Cannot be same"
                        : ""}
                  </FormHelperText>
                </div>
                <div className={Styles.newFeildWrapper}>
                  <div className={Styles.labeltext}>Relationship</div>
                  <div className={Styles.textfields}>
                    <DropdownComp
                      LabelName="Relationship"
                      menuItems={relationShipData}
                      name="relationShip"
                      value={nominee.relationShip}
                      handleChange={(event: any) => {
                        handleChangeField(
                          "relationShip",
                          event.target.value,
                          setFieldValue,
                          index,
                          values,
                          setErrors,
                          errors,
                          setTouched,
                          touched,
                        );
                      }}
                      error={
                        touchedData.relationShip &&
                        errorData &&
                        Boolean(errorData["relationShip"])
                      }
                      onBlur={handleBlur}
                      helperText={
                        touchedData.relationShip &&
                        errorData &&
                        errorData["relationShip"]
                      }
                    />
                  </div>
                </div>
                <div className={Styles.newFeildWrapper}>
                  <div className={Styles.labeltext}>Nominee Date of Birth</div>
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    // style={{ width: "100%" }}
                  >
                    <DatePicker
                      minDate={maxDate}
                      maxDate={dateCheck}
                      disableFuture
                      components={{
                        OpenPickerIcon: DateIcon,
                      }}
                      id="dateofbirthNomineeDateofBirth"
                      placeholder="Nominee Date of Birth"
                      name="nomineeDateofBirth"
                      format="DD/MM/YYYY"
                      views={["year", "month", "day"]}
                      value={nominee.nomineeDateofBirth}
                      className={Styles.datepicker}
                      onChange={(date) => {
                        //console.log("date", date);
                        handleChangeField(
                          "nomineeDateofBirth",
                          date,
                          setFieldValue,
                          index,
                          values,
                          setErrors,
                          errors,
                          setTouched,
                          touched,
                        );
                      }}
                      onBlur={handleBlur}
                      error={
                        (touchedData.nomineeDateofBirth &&
                          errorData &&
                          Boolean(errorData["nomineeDateofBirth"])) ||
                        dateCheckError
                      }
                      helperText={
                        (touchedData.nomineeDateofBirth &&
                          errorData &&
                          errorData["nomineeDateofBirth"]) ||
                        dateCheckError
                      }
                      renderInput={(params: any) => <TextField {...params} />}
                      // views={undefined}
                      {...(DatePicker as any)}
                      InputLabelProps={{
                        sx: {
                          color: "grey", // Default label color
                          fontWeight: 400,
                          fontSize: "14px",
                          "&.MuiFormLabel-filled": {
                            color: "var(--ds-text-primary)", // Label color when a value is selected
                            fontFamily: "inherit",
                          },
                        },
                      }}
                      sx={{
                        width: "100%",
                        fieldset: {
                          borderColor: "#E5E7EB",
                        },
                        "& .MuiInputLabel-root": {
                          color: "var(--ds-text-primary)", // Default label color for date picker
                          fontWeight: 400,
                          fontSize: "14px",
                          "&.Mui-focused": {
                            color: "var(--ds-text-primary)",
                          },
                          "&.MuiFormLabel-filled": {
                            color: "var(--ds-text-primary)",
                            fontWeight: 400,
                            fontSize: "15px",
                            fontFamily: "inherit",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          color: "var(--ds-text-primary)",
                          fontSize: "14px",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <FormHelperText
                    style={{ color: "#d32f2f", marginLeft: "13px" }}
                  >
                    {(touchedData.nomineeDateofBirth &&
                      errorData &&
                      errorData["nomineeDateofBirth"]) ||
                      dateCheckError}
                  </FormHelperText>
                </div>
              </div>

              <div className={Styles.NewDesignWrapper}>
                <div className={Styles.newFeildWrapper}>
                  <div className={Styles.labeltext}>Percentage of Share</div>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    className={Styles.textfields}
                    id="outlined-basic"
                    placeholder="Percentage of Share"
                    variant="outlined"
                    name="percentageofShare"
                    value={nominee.percentageofShare}
                    error={
                      touchedData.percentageofShare &&
                      errorData &&
                      Boolean(errorData["percentageofShare"])
                    }
                    helperText={
                      touchedData.percentageofShare &&
                      errorData &&
                      errorData["percentageofShare"]
                    }
                    onChange={(event) => {
                      handleChangeField(
                        "percentageofShare",
                        event.target.value,
                        setFieldValue,
                        index,
                        values,
                        setErrors,
                        errors,
                        setTouched,
                        touched,
                      );
                    }}
                    onBlur={handleBlur}
                    inputProps={{
                      sx: {
                        "&::label": {
                          fill: "var(--ds-text-primary)",
                          fontWeight: 400,
                          fontSize: "14px",
                        },
                        color: "var(--ds-text-primary)",
                        fontSize: "14px",
                      },
                      maxLength: 3,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      onInput: (event: React.ChangeEvent<HTMLInputElement>) => {
                        const value: any = event.target.value;
                        if (value > 100) {
                          event.target.value = "100";
                        }
                        if (value <= 0) {
                          event.target.value = "";
                        }
                      },
                    }}
                    onKeyPress={(event) => {
                      const keyCode = event.keyCode || event.which;
                      const keyValue = String.fromCharCode(keyCode);
                      const isValidKey = /^\d+$/.test(keyValue);

                      if (!isValidKey) {
                        event.preventDefault();
                      }
                    }}
                    sx={{
                      fieldset: {
                        borderColor: "#E5E7EB",
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        color: "var(--ds-text-primary)",
                        fontWeight: 400,
                        fontSize: "14px",
                        "&.MuiFormLabel-filled": {
                          color: "var(--ds-text-primary)",
                          fontWeight: 400,
                          fontSize: "15px",
                          fontFamily: "inherit",
                        },
                      },
                    }}
                  />

                  <FormHelperText
                    style={{ color: "#d32f2f", textAlign: "center" }}
                  >
                    {touchedData.percentageofShare &&
                      percentageTotal > 100 &&
                      "Percenatge of Share should not exceed 100%"}
                  </FormHelperText>
                </div>
                {showAdditionalDetails ? (
                  <div className={Styles.checkBox}>
                    <Checkbox
                      checked={address.address === nominee.nomineeAddress}
                      onChange={(event) => {
                        handleSetAddress(
                          values,
                          setFieldValue,
                          index,
                          event.target.checked,
                        );
                      }}
                      sx={{
                        marginRight: "5px",
                        width: "20px",
                        height: "20px",
                        marginTop: "4px",
                      }}
                      icon={<img src={Checkboxempty} />}
                      checkedIcon={<img src={Checkboxdone} />}
                    />
                    <p className={Styles.mndsam}>
                      Do You Want Nominee address same as Yours (Optional)
                    </p>
                  </div>
                ) : (
                  <div className={Styles.newFeildWrapper}></div>
                )}
                <div className={Styles.newFeildWrapper}>
                  {nominee.relationShip?.value === "Others" && (
                    <>
                      <div className={Styles.labeltext}>
                        RelationShip Others
                      </div>
                      <TextField
                        autoComplete="off"
                        fullWidth
                        className={Styles.textfieldsOthers}
                        id="outlined-basic"
                        placeholder="RelationShip Others"
                        variant="outlined"
                        name="relationshipIfOthers"
                        value={nominee.relationshipIfOthers.toUpperCase()}
                        error={
                          touchedData.relationshipIfOthers &&
                          errorData &&
                          Boolean(errorData["relationshipIfOthers"])
                        }
                        helperText={
                          touchedData.relationshipIfOthers &&
                          errorData &&
                          errorData["relationshipIfOthers"]
                        }
                        onChange={(event) => {
                          handleChangeField(
                            "relationshipIfOthers",
                            event.target.value,
                            setFieldValue,
                            index,
                            values,
                            setErrors,
                            errors,
                            setTouched,
                            touched,
                          );
                        }}
                        onBlur={handleBlur}
                        inputProps={{
                          sx: {
                            "&::label": {
                              fill: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                            color: "var(--ds-text-primary)",
                            fontSize: "14px",
                          },
                          maxLength: 50,
                          inputMode: "text",
                        }}
                        sx={{
                          fieldset: {
                            borderColor: "#E5E7EB",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "var(--ds-text-primary)",
                            fontWeight: 400,
                            fontSize: "14px",
                            "&.MuiFormLabel-filled": {
                              color: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "15px",
                              fontFamily: "inherit",
                            },
                          },
                        }}
                      />
                    </>
                  )}
                </div>
                {/* <div className={Styles.newFeildWrapper}></div> */}
              </div>

              {showAdditionalDetails && (
                <>
                  <p className={Styles.nomineeContactDetails}>
                    Nominee Contact
                  </p>
                  <div className={Styles.NewDesignWrapper}>
                    <div className={Styles.newFeildWrapper}>
                      <div className={Styles.labeltext}>
                        Nominee Address (Optional)
                      </div>
                      <TextField
                        autoComplete="new-password"
                        fullWidth
                        id="nomineeAddress"
                        className={Styles.addressfields}
                        name="nomineeAddress"
                        placeholder="Nominee Address"
                        variant="outlined"
                        // placeholder="Nominee Address"
                        value={nominee.nomineeAddress.toUpperCase()}
                        onChange={(event) => {
                          // console.log("setErrors", touched);
                          handleChangeField(
                            "nomineeAddress",
                            event.target.value,
                            setFieldValue,
                            index,
                            values,
                            setErrors,
                            errors,
                            setTouched,
                            touched,
                          );
                        }}
                        onBlur={handleBlur}
                        error={
                          touchedData.nomineeAddress &&
                          errorData &&
                          Boolean(errorData["nomineeAddress"])
                        }
                        helperText={
                          touchedData.nomineeAddress &&
                          errorData &&
                          errorData["nomineeAddress"]
                        }
                        inputProps={{
                          sx: {
                            "&::label": {
                              fill: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                            color: "var(--ds-text-primary)",
                            fontSize: "14px",
                          },
                          maxLength: 250,
                          inputMode: "text",
                        }}
                        sx={{
                          fieldset: {
                            borderColor: "#E5E7EB",
                            // borderRadius: "100px",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "var(--ds-text-primary)",
                            fontWeight: 400,
                            fontSize: "14px",
                            "&.MuiFormLabel-filled": {
                              color: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "15px",
                              fontFamily: "inherit",
                            },
                          },
                        }}
                      />
                    </div>
                    <div className={Styles.newFeildWrapper}>
                      <div className={Styles.labeltext}>
                        Nominee Pincode (Optional)
                      </div>
                      <TextField
                        autoComplete="new-password"
                        fullWidth
                        className={Styles.pincodeField}
                        id="outlined-basic"
                        placeholder="Nominee Pincode"
                        variant="outlined"
                        name="nomineeAddressPinCode"
                        value={nominee.nomineeAddressPinCode}
                        error={
                          touchedData.nomineeAddressPinCode &&
                          errorData &&
                          Boolean(errorData["nomineeAddressPinCode"])
                        }
                        helperText={
                          touchedData.nomineeAddressPinCode &&
                          errorData &&
                          errorData["nomineeAddressPinCode"]
                        }
                        onChange={(event) => {
                          handleChangeField(
                            "nomineeAddressPinCode",
                            event.target.value,
                            setFieldValue,
                            index,
                            values,
                            setErrors,
                            errors,
                            setTouched,
                            touched,
                          );
                        }}
                        onBlur={handleBlur}
                        // disabled={address.pincode === nominee.nomineeAddressPinCode}

                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const isValidKey = /^\d+$/.test(keyValue);

                          if (!isValidKey) {
                            event.preventDefault();
                          }
                        }}
                        inputProps={{
                          sx: {
                            "&::label": {
                              fill: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                            color: "var(--ds-text-primary)",
                            fontSize: "14px",
                          },
                          maxLength: 6,
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                        }}
                        sx={{
                          fieldset: {
                            borderColor: "#E5E7EB",
                            // borderRadius: "100px",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "var(--ds-text-primary)",
                            fontWeight: 400,
                            fontSize: "14px",
                            "&.MuiFormLabel-filled": {
                              color: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "15px",
                              fontFamily: "inherit",
                            },
                          },
                        }}
                      />
                    </div>
                    <div className={Styles.newFeildWrapper}>
                      <div className={Styles.labeltext}>
                        Nominee City (Optional)
                      </div>
                      <TextField
                        autoComplete="new-password"
                        fullWidth
                        className={Styles.textfields}
                        id="outlined-basic"
                        placeholder="Nominee City"
                        variant="outlined"
                        name="nomineeAddressCity"
                        value={nominee.nomineeAddressCity.toUpperCase()}
                        error={
                          touchedData.nomineeAddressCity &&
                          errorData &&
                          Boolean(errorData["nomineeAddressCity"])
                        }
                        helperText={
                          touchedData.nomineeAddressCity &&
                          errorData &&
                          errorData["nomineeAddressCity"]
                        }
                        onChange={(event) => {
                          handleChangeField(
                            "nomineeAddressCity",
                            event.target.value,
                            setFieldValue,
                            index,
                            values,
                            setErrors,
                            errors,
                            setTouched,
                            touched,
                          );
                        }}
                        onBlur={handleBlur}
                        inputProps={{
                          sx: {
                            "&::label": {
                              fill: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                            color: "var(--ds-text-primary)",
                            fontSize: "14px",
                          },
                          maxLength: 50,
                          inputMode: "text",
                        }}
                        sx={{
                          fieldset: {
                            borderColor: "#E5E7EB",
                            // borderRadius: "100px",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "var(--ds-text-primary)",
                            fontWeight: 400,
                            fontSize: "14px",
                            "&.MuiFormLabel-filled": {
                              color: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "15px",
                              fontFamily: "inherit",
                            },
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className={Styles.NewDesignWrapper}>
                    <div className={Styles.newFeildWrapper}>
                      <div className={Styles.labeltext}>
                        Nominee State (Optional)
                      </div>
                      <DropdownComp
                        LabelName="Nominee State"
                        menuItems={statesData}
                        name="nomineeAddressState"
                        value={
                          nominee.nomineeAddressState
                            ? nominee.nomineeAddressState
                            : ""
                        }
                        // disabled={SelectedStateNew === nominee.nomineeAddressState}
                        handleChange={(event: any) => {
                          handleChangeField(
                            "nomineeAddressState",
                            event.target.value,
                            setFieldValue,
                            index,
                            values,
                            setErrors,
                            errors,
                            setTouched,
                            touched,
                          );
                        }}
                        onBlur={handleBlur}
                        error={
                          touchedData.nomineeAddressState &&
                          errorData &&
                          Boolean(errorData["nomineeAddressState"])
                        }
                        helperText={
                          touchedData.nomineeAddressState &&
                          errorData &&
                          errorData["nomineeAddressState"]
                        }
                        //   setOthers={setOccupationOthers}
                      />
                    </div>
                    <div className={Styles.newFeildWrapper}>
                      <div className={Styles.labeltext}>
                        Nominee Email (Optional)
                      </div>
                      <TextField
                        autoComplete="new-password"
                        fullWidth
                        className={Styles.textfields}
                        id="outlined-basic"
                        type="email"
                        placeholder="Nominee's Email"
                        variant="outlined"
                        name="nomineeEmail"
                        value={nominee.nomineeEmail}
                        error={
                          touchedData.nomineeEmail &&
                          errorData &&
                          Boolean(errorData["nomineeEmail"])
                        }
                        helperText={
                          touchedData.nomineeEmail &&
                          errorData &&
                          errorData["nomineeEmail"]
                        }
                        onChange={(event) => {
                          handleChangeField(
                            "nomineeEmail",
                            event.target.value,
                            setFieldValue,
                            index,
                            values,
                            setErrors,
                            errors,
                            setTouched,
                            touched,
                          );
                        }}
                        onKeyDown={(event) => {
                          if (event.key === " ") {
                            event.preventDefault();
                          }
                        }}
                        onBlur={handleBlur}
                        inputProps={{
                          sx: {
                            "&::label": {
                              fill: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                            color: "var(--ds-text-primary)",
                            fontSize: "14px",
                          },
                          maxLength: 50,
                          inputMode: "text",
                        }}
                        sx={{
                          fieldset: {
                            borderColor: "#E5E7EB",
                            // borderRadius: "100px",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "var(--ds-text-primary)",
                            fontWeight: 400,
                            fontSize: "14px",
                            "&.MuiFormLabel-filled": {
                              color: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "15px",
                              fontFamily: "inherit",
                            },
                          },
                        }}
                      />
                    </div>
                    <div className={Styles.newFeildWrapper}>
                      <div className={Styles.labeltext}>
                        Nominee Mobile Number (Optional)
                      </div>
                      <TextField
                        fullWidth
                        autoComplete="new-password"
                        className={Styles.textfields}
                        id="outlined-basic"
                        placeholder="Nominee's Mobile Number"
                        variant="outlined"
                        name="nomineeMobileNumber"
                        value={nominee.nomineeMobileNumber}
                        error={
                          touchedData.nomineeMobileNumber &&
                          errorData &&
                          Boolean(errorData["nomineeMobileNumber"])
                        }
                        helperText={
                          touchedData.nomineeMobileNumber &&
                          errorData &&
                          errorData["nomineeMobileNumber"]
                        }
                        onChange={(event) => {
                          handleChangeField(
                            "nomineeMobileNumber",
                            event.target.value,
                            setFieldValue,
                            index,
                            values,
                            setErrors,
                            errors,
                            setTouched,
                            touched,
                          );
                        }}
                        onBlur={handleBlur}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const isValidKey = /^\d+$/.test(keyValue);

                          if (!isValidKey) {
                            event.preventDefault();
                          }
                        }}
                        inputProps={{
                          sx: {
                            "&::label": {
                              fill: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                            color: "var(--ds-text-primary)",
                            fontSize: "14px",
                          },
                          maxLength: 10,
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                        }}
                        sx={{
                          fieldset: {
                            borderColor: "#E5E7EB",
                            // borderRadius: "100px",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "var(--ds-text-primary)",
                            fontWeight: 400,
                            fontSize: "14px",
                            "&.MuiFormLabel-filled": {
                              color: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "15px",
                              fontFamily: "inherit",
                            },
                          },
                        }}
                      />
                    </div>
                  </div>
                </>
              )}

              {nominee.relationShip?.guardian_req &&
              !check18YearOfAge(nominee.nomineeDateofBirth) ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <p className={Styles.nomineeContactDetails}>
                      Guardian Details
                    </p>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Checkbox
                        size="small"
                        checked={showGuardianAdditionalDetails}
                        onChange={(event) =>
                          setShowGuardianAdditionalDetails(event.target.checked)
                        }
                      />
                      <span style={{ fontSize: "12px" }}>
                        Add Additional Details
                      </span>
                    </div>
                  </div>
                  <div className={Styles.NewDesignWrapper}>
                    <div className={Styles.newFeildWrapper}>
                      <div className={Styles.labeltext}>
                        Guardian's First name
                      </div>
                      <TextField
                        autoComplete="new-password"
                        fullWidth
                        className={Styles.textfields}
                        id="outlined-basic"
                        placeholder="Guardian's First name"
                        variant="outlined"
                        name="gaurdianFirstName"
                        value={nominee.gaurdianFirstName}
                        error={
                          touchedData.gaurdianFirstName &&
                          errorData &&
                          Boolean(errorData["gaurdianFirstName"])
                        }
                        helperText={
                          touchedData.gaurdianFirstName &&
                          errorData &&
                          errorData["gaurdianFirstName"]
                        }
                        onChange={(event) => {
                          handleChangeField(
                            "gaurdianFirstName",
                            event.target.value.toUpperCase(),
                            setFieldValue,
                            index,
                            values,
                            setErrors,
                            errors,
                            setTouched,
                            touched,
                          );
                        }}
                        onBlur={handleBlur}
                        inputProps={{
                          sx: {
                            "&::label": {
                              fill: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                            color: "var(--ds-text-primary)",
                            fontSize: "14px",
                          },
                          maxLength: 50,
                          inputMode: "text",
                        }}
                        sx={{
                          fieldset: {
                            borderColor: "#E5E7EB",
                            // borderRadius: "100px",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "var(--ds-text-primary)",
                            fontWeight: 400,
                            fontSize: "14px",
                            "&.MuiFormLabel-filled": {
                              color: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "15px",
                              fontFamily: "inherit",
                            },
                          },
                        }}
                      />
                    </div>
                    <div className={Styles.newFeildWrapper}>
                      <div className={Styles.labeltext}>
                        Guardian's Last name
                      </div>
                      <TextField
                        autoComplete="new-password"
                        fullWidth
                        className={Styles.textfields}
                        id="outlined-basic"
                        placeholder="Guardian's Last name"
                        variant="outlined"
                        name="gaurdianLastName"
                        value={nominee.gaurdianLastName}
                        error={
                          touchedData.gaurdianLastName &&
                          errorData &&
                          Boolean(errorData["gaurdianLastName"])
                        }
                        helperText={
                          touchedData.gaurdianLastName &&
                          errorData &&
                          errorData["gaurdianLastName"]
                        }
                        onChange={(event) => {
                          handleChangeField(
                            "gaurdianLastName",
                            event.target.value.toUpperCase(),
                            setFieldValue,
                            index,
                            values,
                            setErrors,
                            errors,
                            setTouched,
                            touched,
                          );
                        }}
                        onBlur={handleBlur}
                        inputProps={{
                          sx: {
                            "&::label": {
                              fill: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                            color: "var(--ds-text-primary)",
                            fontSize: "14px",
                          },
                          maxLength: 50,
                          inputMode: "text",
                        }}
                        sx={{
                          fieldset: {
                            borderColor: "#E5E7EB",
                            // borderRadius: "100px",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "var(--ds-text-primary)",
                            fontWeight: 400,
                            fontSize: "14px",
                            "&.MuiFormLabel-filled": {
                              color: "var(--ds-text-primary)",
                              fontWeight: 400,
                              fontSize: "15px",
                              fontFamily: "inherit",
                            },
                          },
                        }}
                      />
                    </div>
                    <div className={Styles.newFeildWrapper}>
                      <div className={Styles.labeltext}>
                        Guardian Relation with Nominee
                      </div>
                      <DropdownComp
                        LabelName="Guardian Relation with Nominee"
                        menuItems={
                          filteredRelation
                            ? filteredRelation.filter(
                                (obj) => obj.value !== "Others",
                              )
                            : []
                        }
                        name="gaurdianRelationWithNominee"
                        value={nominee.gaurdianRelationWithNominee}
                        handleChange={(event: any) => {
                          handleChangeField(
                            "gaurdianRelationWithNominee",
                            event.target.value,
                            setFieldValue,
                            index,
                            values,
                            setErrors,
                            errors,
                            setTouched,
                            touched,
                          );
                        }}
                        onBlur={handleBlur}
                        error={
                          touchedData.gaurdianRelationWithNominee &&
                          errorData &&
                          Boolean(errorData["gaurdianRelationWithNominee"])
                        }
                        helperText={
                          touchedData.gaurdianRelationWithNominee &&
                          errorData &&
                          errorData["gaurdianRelationWithNominee"]
                        }
                        //   setOthers={setOccupationOthers}
                      />
                    </div>
                  </div>
                  {showGuardianAdditionalDetails && (
                    <>
                      <div className={Styles.NewDesignWrapper}>
                        <div className={Styles.newFeildWrapper}>
                          <div className={Styles.labeltext}>
                            Guardian Date of Birth (Optional)
                          </div>
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            // style={{ width: "100%" }}
                          >
                            <DatePicker
                              disableFuture
                              components={{
                                OpenPickerIcon: DateIcon,
                              }}
                              minDate={maxDate}
                              maxDate={eighteenYearsAgo}
                              views={["year", "month", "day"]}
                              id="dateofbirthGaurdianDateofBirth"
                              placeholder="Guardian Date of Birth"
                              name="gaurdianDateofBirth"
                              format="DD/MM/YYYY"
                              value={
                                nominee.gaurdianDateofBirth === ""
                                  ? null
                                  : nominee.gaurdianDateofBirth
                              }
                              className={Styles.datepicker}
                              onChange={(date) => {
                                //console.log("date", date);
                                handleChangeField(
                                  "gaurdianDateofBirth",
                                  date,
                                  setFieldValue,
                                  index,
                                  values,
                                  setErrors,
                                  errors,
                                  setTouched,
                                  touched,
                                );
                              }}
                              onBlur={handleBlur}
                              error={
                                touchedData.gaurdianDateofBirth &&
                                errorData &&
                                Boolean(errorData["gaurdianDateofBirth"])
                              }
                              helperText={
                                touchedData.gaurdianDateofBirth &&
                                errorData &&
                                errorData["gaurdianDateofBirth"]
                              }
                              renderInput={(params: any) => (
                                <TextField {...params} />
                              )}
                              {...(DatePicker as any)}
                              InputLabelProps={{
                                sx: {
                                  color: "grey", // Default label color
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  "&.MuiFormLabel-filled": {
                                    color: "var(--ds-text-primary)", // Label color when a value is selected
                                    fontFamily: "inherit",
                                  },
                                },
                              }}
                              sx={{
                                width: "100%",
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  // borderRadius: "100px",
                                },
                                "& .MuiInputLabel-root": {
                                  color: "var(--ds-text-primary)", // Default label color for date picker
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  "&.Mui-focused": {
                                    color: "var(--ds-text-primary)",
                                  },
                                  "&.MuiFormLabel-filled": {
                                    color: "var(--ds-text-primary)",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    fontFamily: "inherit",
                                  },
                                },
                                "& .MuiOutlinedInput-input": {
                                  color: "var(--ds-text-primary)",
                                  fontSize: "14px",
                                },
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText
                            style={{ color: "#d32f2f", textAlign: "center" }}
                          >
                            {dateCheckErrorgaurdianDateofBirth}
                          </FormHelperText>
                        </div>
                        <div className={Styles.newFeildWrapper}>
                          <div className={Styles.labeltext}>
                            Guardian's Email (Optional)
                          </div>
                          <TextField
                            autoComplete="new-password"
                            fullWidth
                            className={Styles.textfields}
                            id="outlined-basic"
                            placeholder="Guardian's Email"
                            variant="outlined"
                            name="gaurdianEmail"
                            value={nominee.gaurdianEmail}
                            error={
                              touchedData.gaurdianEmail &&
                              errorData &&
                              Boolean(errorData["gaurdianEmail"])
                            }
                            helperText={
                              touchedData.gaurdianEmail &&
                              errorData &&
                              errorData["gaurdianEmail"]
                            }
                            onChange={(event) => {
                              handleChangeField(
                                "gaurdianEmail",
                                event.target.value,
                                setFieldValue,
                                index,
                                values,
                                setErrors,
                                errors,
                                setTouched,
                                touched,
                              );
                            }}
                            onKeyDown={(event) => {
                              if (event.key === " ") {
                                event.preventDefault();
                              }
                            }}
                            onBlur={handleBlur}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "var(--ds-text-primary)",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                },
                                color: "var(--ds-text-primary)",
                                fontSize: "14px",
                              },
                              maxLength: 50,
                              inputMode: "text",
                            }}
                            sx={{
                              fieldset: {
                                borderColor: "#E5E7EB",
                                // borderRadius: "100px",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "var(--ds-text-primary)",
                                fontWeight: 400,
                                fontSize: "14px",
                                "&.MuiFormLabel-filled": {
                                  color: "var(--ds-text-primary)",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  fontFamily: "inherit",
                                },
                              },
                            }}
                          />
                        </div>
                        <div className={Styles.newFeildWrapper}>
                          <div className={Styles.labeltext}>
                            Guardian's Mobile Number (Optional)
                          </div>
                          <TextField
                            autoComplete="new-password"
                            fullWidth
                            className={Styles.textfields}
                            id="outlined-basic"
                            placeholder="Guardian's Mobile Number"
                            variant="outlined"
                            name="gaurdianMobileNumber"
                            value={nominee.gaurdianMobileNumber}
                            error={
                              touchedData.gaurdianMobileNumber &&
                              errorData &&
                              Boolean(errorData["gaurdianMobileNumber"])
                            }
                            helperText={
                              touchedData.gaurdianMobileNumber &&
                              errorData &&
                              errorData["gaurdianMobileNumber"]
                            }
                            onChange={(event) => {
                              handleChangeField(
                                "gaurdianMobileNumber",
                                event.target.value,
                                setFieldValue,
                                index,
                                values,
                                setErrors,
                                errors,
                                setTouched,
                                touched,
                              );
                            }}
                            onBlur={handleBlur}
                            onKeyPress={(event) => {
                              const keyCode = event.keyCode || event.which;
                              const keyValue = String.fromCharCode(keyCode);
                              const isValidKey = /^\d+$/.test(keyValue);

                              if (!isValidKey) {
                                event.preventDefault();
                              }
                            }}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "var(--ds-text-primary)",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                },
                                color: "var(--ds-text-primary)",
                                fontSize: "14px",
                              },
                              maxLength: 10,
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                            }}
                            sx={{
                              fieldset: {
                                borderColor: "#E5E7EB",
                                // borderRadius: "100px",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "var(--ds-text-primary)",
                                fontWeight: 400,
                                fontSize: "14px",
                                "&.MuiFormLabel-filled": {
                                  color: "var(--ds-text-primary)",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  fontFamily: "inherit",
                                },
                              },
                            }}
                          />
                        </div>
                      </div>
                      <div className={Styles.NewDesignWrapper}>
                        <div
                          className={Styles.checkBox}
                          // style={{ marginBottom: "20px" }}
                        >
                          <Checkbox
                            checked={
                              address.address === nominee.gaurdianAddress
                            }
                            onChange={(event) => {
                              handleSetGaurdianAddress(
                                values,
                                setFieldValue,
                                index,
                                event.target.checked,
                              );
                            }}
                            sx={{
                              marginRight: "5px",
                              width: "20px",
                              height: "20px",
                              marginTop: "4px",
                            }}
                            icon={
                              <img
                                src={Checkboxempty}
                                // style={{
                                //   filter:
                                //     mode === "dark"
                                //       ? "grayscale(0.9) invert(0.9) brightness(1)"
                                //       : "",
                                // }}
                              />
                            }
                            checkedIcon={<img src={Checkboxdone} />}
                          />
                          <p className={Styles.mndsam}>
                            Make Guardian address same as mine (Optional)
                          </p>
                        </div>
                        <div className={Styles.newFeildWrapper}></div>
                        <div className={Styles.newFeildWrapper}></div>
                      </div>

                      <div className={Styles.NewDesignWrapper}>
                        <div className={Styles.newFeildWrapper}>
                          <div className={Styles.labeltext}>
                            Guardian Address (Optional)
                          </div>
                          <TextField
                            autoComplete="new-password"
                            className={Styles.addressfields}
                            id="outlined-basic"
                            placeholder="Guardian Address"
                            variant="outlined"
                            name="gaurdianAddress"
                            value={
                              nominee.gaurdianAddress
                                ? nominee.gaurdianAddress
                                : ""
                            }
                            // InputLabelProps={{ shrink: true }}
                            error={
                              touchedData.gaurdianAddress &&
                              errorData &&
                              Boolean(errorData["gaurdianAddress"])
                            }
                            helperText={
                              touchedData.gaurdianAddress &&
                              errorData &&
                              errorData["gaurdianAddress"]
                            }
                            onChange={(event) => {
                              handleChangeField(
                                "gaurdianAddress",
                                event.target.value.toUpperCase(),
                                setFieldValue,
                                index,
                                values,
                                setErrors,
                                errors,
                                setTouched,
                                touched,
                              );
                            }}
                            onBlur={handleBlur}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "var(--ds-text-primary)",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                },
                                color: "var(--ds-text-primary)",
                                fontSize: "14px",
                              },
                              maxLength: 250,
                              inputMode: "text",
                            }}
                            sx={{
                              fieldset: {
                                borderColor: "#E5E7EB",
                                // borderRadius: "100px",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "var(--ds-text-primary)",
                                fontWeight: 400,
                                fontSize: "14px",
                                "&.MuiFormLabel-filled": {
                                  color: "var(--ds-text-primary)",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  fontFamily: "inherit",
                                },
                              },
                            }}
                          />
                        </div>
                        <div className={Styles.newFeildWrapper}>
                          <div className={Styles.labeltext}>
                            Guardian Pincode (Optional)
                          </div>
                          <TextField
                            autoComplete="new-password"
                            fullWidth
                            className={Styles.textfields}
                            id="outlined-basic"
                            placeholder="Guardian Pincode"
                            variant="outlined"
                            name="gaurdianAddressPinCode"
                            value={
                              nominee.gaurdianAddressPinCode
                                ? nominee.gaurdianAddressPinCode
                                : ""
                            }
                            // InputLabelProps={{ shrink: true }}
                            error={
                              touchedData.gaurdianAddressPinCode &&
                              errorData &&
                              Boolean(errorData["gaurdianAddressPinCode"])
                            }
                            helperText={
                              touchedData.gaurdianAddressPinCode &&
                              errorData &&
                              errorData["gaurdianAddressPinCode"]
                            }
                            onChange={(event) => {
                              handleChangeField(
                                "gaurdianAddressPinCode",
                                event.target.value,
                                setFieldValue,
                                index,
                                values,
                                setErrors,
                                errors,
                                setTouched,
                                touched,
                              );
                            }}
                            onBlur={handleBlur}
                            onKeyPress={(event) => {
                              const keyCode = event.keyCode || event.which;
                              const keyValue = String.fromCharCode(keyCode);
                              const isValidKey = /^\d+$/.test(keyValue);

                              if (!isValidKey) {
                                event.preventDefault();
                              }
                            }}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "var(--ds-text-primary)",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                },
                                color: "var(--ds-text-primary)",
                                fontSize: "14px",
                              },
                              maxLength: 6,
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                            }}
                            sx={{
                              fieldset: {
                                borderColor: "#E5E7EB",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "var(--ds-text-primary)",
                                fontWeight: 400,
                                fontSize: "14px",
                                "&.MuiFormLabel-filled": {
                                  color: "var(--ds-text-primary)",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  fontFamily: "inherit",
                                },
                              },
                            }}
                          />
                        </div>
                        <div className={Styles.newFeildWrapper}>
                          <div className={Styles.labeltext}>
                            Guardian City (Optional)
                          </div>
                          <TextField
                            autoComplete="new-password"
                            fullWidth
                            className={Styles.textfields}
                            id="outlined-basic"
                            placeholder="Guardian City"
                            variant="outlined"
                            name="gaurdianAddressCity"
                            value={
                              nominee.gaurdianAddressCity
                                ? nominee.gaurdianAddressCity
                                : ""
                            }
                            // InputLabelProps={{ shrink: true }}
                            error={
                              touchedData.gaurdianAddressCity &&
                              errorData &&
                              Boolean(errorData["gaurdianAddressCity"])
                            }
                            helperText={
                              touchedData.gaurdianAddressCity &&
                              errorData &&
                              errorData["gaurdianAddressCity"]
                            }
                            onChange={(event) => {
                              handleChangeField(
                                "gaurdianAddressCity",
                                event.target.value.toUpperCase(),
                                setFieldValue,
                                index,
                                values,
                                setErrors,
                                errors,
                                setTouched,
                                touched,
                              );
                            }}
                            onBlur={handleBlur}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "var(--ds-text-primary)",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                },
                                color: "var(--ds-text-primary)",
                                fontSize: "14px",
                              },
                              maxLength: 50,
                              inputMode: "text",
                            }}
                            sx={{
                              fieldset: {
                                borderColor: "#E5E7EB",
                                // borderRadius: "100px",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "var(--ds-text-primary)",
                                fontWeight: 400,
                                fontSize: "14px",
                                "&.MuiFormLabel-filled": {
                                  color: "var(--ds-text-primary)",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  fontFamily: "inherit",
                                },
                              },
                            }}
                          />
                        </div>
                      </div>

                      <div className={Styles.NewDesignWrapper}>
                        <div className={Styles.newFeildWrapper}>
                          <div className={Styles.labeltext}>
                            Guardian State (Optional)
                          </div>
                          <DropdownComp
                            LabelName="Guardian State"
                            menuItems={statesData}
                            name="gaurdianAddressState"
                            value={
                              nominee.gaurdianAddressState
                                ? nominee.gaurdianAddressState
                                : ""
                            }
                            handleChange={(event: any) => {
                              handleChangeField(
                                "gaurdianAddressState",
                                event.target.value,
                                setFieldValue,
                                index,
                                values,
                                setErrors,
                                errors,
                                setTouched,
                                touched,
                              );
                            }}
                            onBlur={handleBlur}
                            error={
                              touchedData.gaurdianAddressState &&
                              errorData &&
                              Boolean(errorData["gaurdianAddressState"])
                            }
                            helperText={
                              touchedData.gaurdianAddressState &&
                              errorData &&
                              errorData["gaurdianAddressState"]
                            }
                          />
                        </div>
                        <div className={Styles.newFeildWrapper}></div>
                        <div className={Styles.newFeildWrapper}></div>
                      </div>
                    </>
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        {currentIndex === index && showAdditionalDetails && (
          <SelectProof
            textFieldName={"nomineeIDProofNo"}
            radioGroupValue={nominee.nomineeIDProof}
            textFieldValue={nominee.nomineeIDProofNo.toUpperCase()}
            textFieldLabel={nominee.noimineeIDProofNo}
            textFieldError={
              touchedData.nomineeIDProofNo &&
              errorData &&
              Boolean(errorData["nomineeIDProofNo"])
            }
            onTextFieldChange={(event) => {
              handleChangeField(
                "nomineeIDProofNo",
                event.target.value,
                setFieldValue,
                index,
                values,
                setErrors,
                errors,
                setTouched,
                touched,
              );
            }}
            textFieldHelperText={
              touchedData.nomineeIDProofNo &&
              errorData &&
              errorData["nomineeIDProofNo"]
            }
            radioGroups={nomineeID}
            index={index}
            currentIndex={currentIndex}
            name={"nomineeIDProof"}
            values={values}
            handleRadioButtonFieldChange={(event) => {
              handleChangeField(
                "nomineeIDProof",
                event.target.value,
                setFieldValue,
                index,
                values,
                setErrors,
                errors,
                setTouched,
                touched,
              );
            }}
            helperText={errorData && errorData["nomineeIDProof"]}
            variant={"outlined"}
            handleBlur={handleBlur}
            mode={mode}
          />
        )}
      </div>
    </div>
  );
}
